import React from "react";

function AccessibleIcon() {
  return (
    <svg
      width="24"
      height="29"
      viewBox="0 0 24 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.3457 3.88769C8.3457 4.65356 8.64994 5.38805 9.19149 5.9296C9.73304 6.47115 10.4675 6.77539 11.2334 6.77539C11.9993 6.77539 12.7338 6.47115 13.2753 5.9296C13.8169 5.38805 14.1211 4.65356 14.1211 3.88769C14.1211 3.12183 13.8169 2.38733 13.2753 1.84579C12.7338 1.30424 11.9993 1 11.2334 1C10.4675 1 9.73304 1.30424 9.19149 1.84579C8.64994 2.38733 8.3457 3.12183 8.3457 3.88769Z"
        stroke="#2D2020"
        strokeWidth="2"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.2324 6.77539V18.3262H17.0078L22.7832 25.5454M11.2324 12.5508H18.4517M5.45704 13.2727C4.42252 13.7011 3.50183 14.3643 2.76777 15.2099C2.0337 16.0554 1.50639 17.0601 1.2275 18.1445C0.948617 19.229 0.92581 20.3634 1.16089 21.4582C1.39596 22.553 1.88247 23.5781 2.58196 24.4524C3.28145 25.3268 4.17473 26.0264 5.1912 26.4961C6.20767 26.9658 7.31946 27.1925 8.43867 27.1585C9.55788 27.1245 10.6538 26.8306 11.6399 26.3C12.6259 25.7694 13.4751 25.0168 14.1201 24.1015"
        stroke="#2D2020"
        strokeWidth="2"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default AccessibleIcon;
